export default {
  init() {
    const body = $('body');

    // Custom Dropdown for Mobile booking
    const rsdDropdown = $('.rsd-dropdown');
    if (rsdDropdown.length) {
      rsdDropdown.each(function() {
        let thisDropdown = $(this);
        let dropdownId = thisDropdown.data('rsd-dropdown');
        let disableForm = false;
        let hotelBookingContainer = thisDropdown.closest('.hotel-booking-form-container, .hotel-booking-fixed-lg, .hotel-booking-widget-container');

        if (thisDropdown.data('rsd-disable-form')) {
          disableForm = thisDropdown.data('rsd-disable-form');
        }

        thisDropdown.on('click', function() {
          $('#' + dropdownId).toggle();

          if (disableForm) {
            hotelBookingContainer.toggleClass('disable');
            if (hotelBookingContainer.hasClass('hotel-booking-fixed-lg')) {
              body.toggleClass('bookwidget-guests');
            }
          }
        });

        if (hotelBookingContainer.length) {
          hotelBookingContainer.find('.apply-btn').on('click', function() {
            $('#' + dropdownId).hide();
            hotelBookingContainer.removeClass('disable');

            if (hotelBookingContainer.hasClass('hotel-booking-fixed-lg')) {
              body.removeClass('bookwidget-guests');
            }
          });

          // hide when clicked outside dropdown
          $(document).on('click', function(event) {
            if (
              !hotelBookingContainer.is(event.target) && hotelBookingContainer.has(event.target).length === 0
            ) {
              $('#' + dropdownId).hide();
              hotelBookingContainer.removeClass('disable');

              if (hotelBookingContainer.hasClass('hotel-booking-fixed-lg')) {
                body.removeClass('bookwidget-guests');
              }
            }
          });
        }
      });
    }

    const commonHotelBookingWidget = $('section.common-hotel-booking-widget');
    if (commonHotelBookingWidget.length) {
      // Open Hotel Mobile Booking
      let bodyScrollDistance = 0;
      let bodyAdminBarOffset = 0;

      if (body.hasClass('admin-bar')) {
        if ($(window).width() > 783) {
          bodyAdminBarOffset = 32;
        } else {
          bodyAdminBarOffset = 46;
        }
      }

      const mobileBookingWidgetToggle = commonHotelBookingWidget.find('.mobile-booking-widget-toggle');
      if (mobileBookingWidgetToggle.length) {
        mobileBookingWidgetToggle.on('click', (e) => {
          e.preventDefault();

          $('.mobile-booking-widget-wrapper').addClass('show');

          // Add top bodyScroll
          bodyScrollDistance = $(window).scrollTop();
          body.css('top', (bodyScrollDistance - bodyAdminBarOffset) * -1);

          body.addClass('modal-open');
        });

        $(document).on('click', function(event) {
          if ($(event.target).hasClass('mobile-booking-widget-wrapper')) {
            $('.mobile-booking-widget-wrapper').removeClass('show');
            body.removeClass('modal-open');

            // Remove top bodyScroll
            body.css('top', '');
            $(window).scrollTop(bodyScrollDistance);
          }
        });
      }

      const bookingWidgetWrapper = commonHotelBookingWidget.find('.booking-widget-wrapper');
      if (bookingWidgetWrapper.length) {
        const toggleDRP = bookingWidgetWrapper.find('.toggle-datepicker-inline').first();
        const bookingWidgetInline = bookingWidgetWrapper.find('.booking-widget-parent-inline').first();
        const inlineCloseBtn = bookingWidgetInline.find('.inline-close-btn').first();
        const dateRangePicker = bookingWidgetWrapper.find('.booking-daterange-picker');

        toggleDRP.on('click', () => {
          bookingWidgetInline.toggleClass('shown');
        });

        inlineCloseBtn.on('click', () => {
          bookingWidgetInline.removeClass('shown');
        });

        dateRangePicker.on('apply.daterangepicker', function() {
          bookingWidgetInline.removeClass('shown');
        });

        $(document).on('click', function(e) {
          if (
            !bookingWidgetInline.is(e.target) &&
            bookingWidgetInline.has(e.target).length === 0 &&
            !toggleDRP.is(e.target) &&
            toggleDRP.has(e.target).length === 0 &&
            !$(e.target).hasClass('next') &&
            !$(e.target).hasClass('prev')
          ) {
            bookingWidgetInline.removeClass('shown');
          }
        });
      }
    }

    // Open Hotel Mobile Booking Modal
    const showHotelMobileBookingBtn = $('.show-hotel-mobile-booking-btn');
    if (showHotelMobileBookingBtn.length) {
      showHotelMobileBookingBtn.on('click', function() {
        $('.hotel-mobile-booking-modal').addClass('show');
        body.addClass('modal-open');
      });

      $(document).on('click', function(event) {
        if (body.hasClass('modal-open')) {
          if ($(event.target).hasClass('hotel-mobile-booking-modal')) {
            $('.hotel-mobile-booking-modal').removeClass('show');
            body.removeClass('modal-open');
          }
        }
      });
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/components/bookingWidgets.js